import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ApiRequest from "./ApiRequest";

const PermissionContext = createContext({ status: "loading", hasPermission: () => false, refresh: () => {} });
export const usePermissions = () => useContext(PermissionContext);

export function PermissionProvider({ children }) {
  const [status, setStatus] = useState("loading");
  const [slugs, setSlugs] = useState(new Set());
  const location = useLocation();
  const navigate = useNavigate();

  const refresh = useCallback(async () => {
    try {
      const response = await ApiRequest("GET", "api/rbac/my-permissions");
      setSlugs(new Set((response.permissions || []).map((item) => item.slug)));
      setStatus("ready");
    } catch (error) {
      setSlugs(new Set());
      setStatus("denied");
      if (error.response?.status === 401) {
        localStorage.removeItem("accessTokenBigbin");
        navigate("/login", { replace: true });
      }
    }
  }, [navigate]);

  useEffect(() => { refresh(); }, [location.pathname, refresh]);
  useEffect(() => {
    const timer = setInterval(refresh, 15000);
    return () => clearInterval(timer);
  }, [refresh]);

  const value = useMemo(() => ({ status, hasPermission: (slug) => status === "ready" && slugs.has(slug), refresh }), [status, slugs, refresh]);
  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
}
